module.exports = __webpack_public_path__ + "img/num1_joy.2e379085.png";